export const hasUncoveredBondDebt = (
  usdAvailable: number,
  bondBorrowed: number,
  bondPrice: number,
) =>
  usdAvailable > Number.EPSILON &&
  bondBorrowed > Number.EPSILON &&
  Number.isFinite(bondPrice) &&
  bondPrice > 0 &&
  bondBorrowed * bondPrice > usdAvailable + Number.EPSILON

export const findBalanceIndex = <T extends { id: string; asset_id: string }>(
  balances: T[],
  update: T,
) =>
  balances.findIndex((balance) => balance.id === update.id && balance.asset_id === update.asset_id)
